import { FeatureModule } from '@store/features/types';
import actionUIReducer from './slice';
import { actionsApi } from './api';
import storage from 'redux-persist/lib/storage'; // localStorage
import sessionStorage from 'redux-persist/lib/storage/session'; // sessionStorage

/**
 * Actions feature module definition
 */
export const actionsFeature: FeatureModule = {
  // Basic feature identification
  id: 'actions',
  name: 'Actions',

  // Optional feature dependencies
  dependencies: [], // No dependencies for this feature

  // Feature reducers
  reducers: {
    'actions/ui': actionUIReducer,
  },

  // No middleware needed for this feature since API is registered separately
  middleware: [],

  persistence: {
    enabled: true, // Enable persistence for draft data
    storage: storage,
    whitelist: ['drafts', 'histories'], // Only persist drafts and versions, not UI state
    debounce: 500,
  },

  sync: {
    enabled: true,
    whitelist: ['drafts', 'histories'], // Sync only drafts and versions
  },

  // Feature lifecycle hooks
  setup: store => {
    // Setup code when feature is registered
    console.log(`${actionsFeature.name} feature initialized`);
  },

  cleanup: store => {
    // Cleanup code when feature is unregistered
    console.log(`${actionsFeature.name} feature cleaned up`);
  },
};

/**
 * Initialize feature - call this when registering the feature
 */
export function initializeActionsFeature() {
  // Initialize API endpoints
  return {
    api: actionsApi,
    feature: actionsFeature,
  };
}
